const {useGlobalConfig} = require('./use-global-config');

module.exports = {
    useGlobalConfig
}